import { getApi } from "./api_instance";

export const getDashboardHighAmount = async (dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: "/projects/api/dashboard/top-credits/amount",
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
